import React                from "react";
import PropTypes            from "prop-types";
import { connect }          from "react-redux";
import Status               from "dashboard/dist/Core/Status";
import Utils                from "dashboard/dist/Utils/Utils";

// Components
import EditDialog           from "dashboard/dist/Components/EditDialog";
import Columns              from "dashboard/dist/Components/Columns";
import InputField           from "dashboard/dist/Components/InputField";

// Actions
import {
    fetchGuideEdit, fetchGuideCreate, editGuide,
} from "Actions/Admin/Strech/GuideActions";



/**
 * The Strech Guide Edit Dialog
 */
class GuideEdit extends React.Component {
    // The Initial Data
    initialData = {
        strechGuideID  : 0,
        strechID       : 0,
        strechClassID  : 0,
        programGuideID : 0,
        guideID        : 0,
        position       : 0,
        status         : Status.getID("ACTIVE"),
    }

    // The Current State
    state = {
        loading : false,
        data    : { ...this.initialData },
        errors  : {},
    }



    /**
     * Get the Data when the Element ID changes
     * @param {Object} prevProps
     * @returns {Void}
     */
    componentDidUpdate(prevProps) {
        const { open, edition, elemID, elem, strechID, position, fetchGuideEdit, fetchGuideCreate } = this.props;
        let loading = false;
        let data    = null;

        // Dialog Opens
        if (open && !prevProps.open) {
            data = { ...this.initialData };
            // Load new data
            if (elemID) {
                fetchGuideEdit(elemID);
                loading = true;
            // Load edit data
            } else if (strechID) {
                fetchGuideCreate(strechID);
                loading = true;
            }

        // Data Updated
        } else if (prevProps.edition !== edition) {
            if (elemID) {
                data = Utils.extend(this.initialData, elem);
            } else {
                data = { ...this.initialData, strechID, position };
            }
        }

        // Set the State
        if (data) {
            this.setState({ data, loading, errors : {} });
        }
    }

    /**
     * Handles the Input Change
     * @param {String} name
     * @param {*}      value
     * @returns {Void}
     */
    handleChange = (name, value) => {
        this.setState({
            data   : { ...this.state.data,   [name] : value },
            errors : { ...this.state.errors, [name] : ""    },
        });
    }

    /**
     * Handles the Submit
     * @returns {Promise}
     */
    handleSubmit = async () => {
        const { data, loading } = this.state;
        if (!loading) {
            this.setState({ loading : true, errors : {} });
            try {
                await this.props.editGuide(data);
                this.setState({ loading : false });
                this.props.onSubmit();
            } catch (errors) {
                this.setState({ loading : false, errors });
            }
        }
    }



    /**
     * Does the Render
     * @returns {Object}
     */
    render() {
        const { elemID, open, onClose, guides, classes } = this.props;
        const { data, loading, errors                  } = this.state;

        return <EditDialog
            open={open}
            icon="guide"
            title={!!elemID ? "GUIDES_EDIT_TITLE" : "GUIDES_ASSIGN_TITLE"}
            error={errors.form}
            onSubmit={this.handleSubmit}
            onClose={onClose}
            isLoading={loading}
        >
            <InputField
                type="select"
                name="guideID"
                label="GUIDES_SINGULAR"
                value={data.guideID}
                error={errors.guideID}
                onChange={this.handleChange}
                options={guides}
                withNone
                isRequired
            />
            <InputField
                type="select"
                name="strechClassID"
                label="GUIDES_CLASS"
                value={data.strechClassID}
                error={errors.strechClassID}
                onChange={this.handleChange}
                options={classes}
                withNone
            />
            <Columns>
                <InputField
                    type="number"
                    name="position"
                    label="GENERAL_POSITION"
                    value={data.position}
                    error={errors.position}
                    onChange={this.handleChange}
                    shrinkLabel
                />
                <InputField
                    type="select"
                    name="status"
                    label="GENERAL_STATUS"
                    value={data.status}
                    error={errors.status}
                    onChange={this.handleChange}
                    options={Status.getFemSelect()}
                    withNone
                    isRequired
                    shrinkLabel
                />
            </Columns>
        </EditDialog>;
    }



    /**
     * The Property Types
     * @typedef {Object} propTypes
     */
    static propTypes = {
        fetchGuideEdit   : PropTypes.func.isRequired,
        fetchGuideCreate : PropTypes.func.isRequired,
        editGuide        : PropTypes.func.isRequired,
        open             : PropTypes.bool.isRequired,
        onClose          : PropTypes.func.isRequired,
        onSubmit         : PropTypes.func.isRequired,
        edition          : PropTypes.number.isRequired,
        position         : PropTypes.number.isRequired,
        guides           : PropTypes.array.isRequired,
        classes          : PropTypes.array.isRequired,
        elem             : PropTypes.object.isRequired,
        elemID           : PropTypes.number,
        strechID         : PropTypes.number,
    }

    /**
     * Maps the State to the Props
     * @param {Object} state
     * @returns {Object}
     */
    static mapStateToProps(state) {
        return {
            edition  : state.strechGuide.edition,
            position : state.strechGuide.position,
            guides   : state.strechGuide.guides,
            classes  : state.strechGuide.classes,
            elem     : state.strechGuide.elem,
        };
    }
}

export default connect(GuideEdit.mapStateToProps, {
    fetchGuideEdit, fetchGuideCreate, editGuide,
})(GuideEdit);
